import { Avatar, CircularProgress, TablePagination } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaDotCircle } from "react-icons/fa";
import { useDispatch } from "react-redux";
import io from "socket.io-client";
import LoadingButton from "../../Common/LoadingButton";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import { NODE_BASE_URL } from "../../config/siteUrls";
import {
  openConfirmationPopup,
  openFailDialog,
} from "../../Redux/Actions/PopupActions";
import userService from "../../services/user.service";
import { formatDuration } from "../../utils/formatTimeDuration";
import { getFromLocalStorage } from "../../utils/webStorage";
import SuperAdminDashboard from "./superAdminDashboard";

const LiveStreamStatus = () => {
  const [channelData, setChannelData] = useState([]);
  const loginRole = getFromLocalStorage("loginRole");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [socket, setSocket] = useState(null);
  const [loadingButton, setLoadingButton] = useState(null);
  const [isShowPastStream, setIsShowPastStream] = useState(false);
  const [pageMetaData, setPageMetaData] = useState({
    page: 0,
    rowsPerPage: 10,
    total: 0,
    filter: "",
  });

  useEffect(() => {
    const socketInstance = io(NODE_BASE_URL);
    socketInstance.on("connect", () => {});
    setSocket(socketInstance);
    getAllLiveIvsChannel();
    return () => {
      socketInstance.disconnect();
    };
  }, []);

  const handleChangePage = (event, newPage) => {
    setPageMetaData((prev) => ({
      ...prev,
      page: newPage,
    }));
    getAllPastIvsChannelByPage({ newPage, filter: pageMetaData.filter });
  };

  const handleChangeRowsPerPage = (event) => {
    setPageMetaData((prev) => ({
      ...prev,
      rowsPerPage: parseInt(event.target.value, 10),
    }));
  };

  const getAllLiveIvsChannel = () => {
    setLoading(true);
    userService
      .getIVSChannelDetailsForSuperAdmin()
      .then((response) => {
        setChannelData(response.data?.data);
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleLiveStreamingClick = () => {
    setIsShowPastStream(false);
    getAllLiveIvsChannel();
  };

  const getAllPastIvsChannelByPage = (data) => {
    const { newPage, filter } = data;
    setLoading(true);
    userService
      .getPastIVSChannelForSuperAdmin(newPage, pageMetaData.rowsPerPage, filter)
      .then((response) => {
        const { ivsChannels, total } = response.data.data;
        setChannelData(ivsChannels);
        setPageMetaData((prev) => ({
          ...prev,
          total: total,
        }));
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePastStreamingClick = () => {
    setIsShowPastStream(true);
    setPageMetaData((prev) => ({ ...prev, page: 0, filter: "7 Days" }));
    getAllPastIvsChannelByPage({ newPage: 0, filter: "7 Days" });
  };

  const deleteButtonHandler = async (data, item) => {
    if (item?.isPrimaryChannel && data?.channels.length != 1) {
      openFailDialog(dispatch, {
        open: true,
        message: "This is parent channel. Please stop other channel first.",
      });
    } else {
      openConfirmationPopup(dispatch, {
        confirmationPopup: {
          open: true,
          message: "Are You Sure, You Want To Delete Channel?",
          btnColor: "red",
          btnText: "Yes",
          type: "Delete IVS channel",
          item: item,
          socket: socket,
          getAllLiveChannel: () => getAllLiveIvsChannel(),
          setLoadingButton: setLoadingButton,
        },
      });
    }
  };

  const deleteAllChannelHandler = (item) => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Delete All Channels?",
        btnColor: "red",
        btnText: "Yes",
        type: "Delete all IVS channel",
        item: item,
        socket,
        getAllLiveChannel: () => getAllLiveIvsChannel(),
        setLoadingButton: setLoadingButton,
      },
    });
  };

  const handleFilterChange = async (event) => {
    const filter = event.target.value;
    setPageMetaData((prev) => ({ ...prev, page: 0, filter }));
    getAllPastIvsChannelByPage({ newPage: 0, filter });
  };

  return (
    <>
      {loginRole === "SUPER ADMIN" ? (
        <div>
          <div className="content">
            <SuperAdminDashboard />
            <div className="content-layout">
              <div className="mng-header d-flex flex-direction-r">
                <div>
                  <button
                    onClick={handleLiveStreamingClick}
                    className="live-stream-btns"
                    style={{
                      borderBottom: !isShowPastStream
                        ? "5px solid #024"
                        : "none",
                    }}
                    disabled={loading || !isShowPastStream}
                  >
                    Live Video Streaming
                  </button>
                  <button
                    onClick={handlePastStreamingClick}
                    className="live-stream-btns"
                    style={{
                      borderBottom: isShowPastStream
                        ? "5px solid #024"
                        : "none",
                    }}
                    disabled={loading || isShowPastStream}
                  >
                    Past Video Streaming
                  </button>
                </div>
                {isShowPastStream && (
                  <div className="d-flex-align-cent flex-direction-r">
                    <span className="bold mr70">Select Filter: </span>
                    <select
                      className="filter-select-box"
                      id="filter-select"
                      value={pageMetaData.filter}
                      onChange={handleFilterChange}
                    >
                      <option value="Today">Today</option>
                      <option value="7 Days">Last 7 Days</option>
                      <option value="30 Days">Last 30 Days</option>
                      <option value="LAST MONTH">Last Month</option>
                      <option value="THIS MONTH">This Month</option>
                      <option value="ALL TIME">All Time</option>
                    </select>
                    <TablePagination
                      component="div"
                      count={pageMetaData.total}
                      page={pageMetaData.page}
                      onPageChange={handleChangePage}
                      rowsPerPage={pageMetaData.rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                )}
              </div>
              {!loading &&
                channelData.length == 0 &&
                (isShowPastStream ? (
                  <p className="page-not-found-heading text-center">
                    No Channel Present
                  </p>
                ) : (
                  <p className="page-not-found-heading text-center">
                    No School Is Live
                  </p>
                ))}
              {loading && (
                <div className="content-layout-loading-animation">
                  <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
                </div>
              )}
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr pt-1 stream-container">
                {!loading &&
                  channelData.map((ele1) => (
                    <div className="white-card shadow main-stream-card">
                      <div
                        className={`${isShowPastStream} ? past-streaming-card : streaming-card`}
                      >
                        <div className="school-row">
                          <Avatar src={ele1.schoolLogo} />
                          <span className="fs-20 black bold">
                            {ele1.homeSchool}
                          </span>
                          {!ele1.isLive && isShowPastStream ? (
                            <span className="fs-18 red bold">
                              Live on :{" "}
                              {moment(ele1?.liveStreamingDate).format(
                                "MMM DD, YYYY, hh:mm A"
                              )}
                            </span>
                          ) : (
                            <span className="live-icon">
                              <FaDotCircle className="green mg-right-5" />
                              Live
                            </span>
                          )}
                        </div>
                        {ele1.channels.map((ele, i) => (
                          <div className="channel-row">
                            <span className="fs-18">
                              Camera Angle{i + 1}:{" "}
                              <i className="bold">{ele.angle}</i>
                              {isShowPastStream && (
                                <>
                                  <span>, Duration: </span>
                                  <span className="skyblue bold">
                                    {formatDuration(
                                      parseInt(ele.totalDuration) * 60
                                    )}
                                  </span>
                                </>
                              )}
                            </span>
                            {!isShowPastStream && (
                              <div
                                onClick={() => deleteButtonHandler(ele1, ele)}
                              >
                                <LoadingButton
                                  text={"Stop"}
                                  loading={loadingButton === ele.channelId}
                                  disabled={loadingButton === ele.channelId}
                                  isZIndex={true}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      {!isShowPastStream && (
                        <div
                          className={`mg-top-20`}
                          onClick={() => deleteAllChannelHandler(ele1)}
                        >
                          <LoadingButton
                            text={"Stop All Channel"}
                            loading={loadingButton === ele1.schoolId}
                            disabled={loadingButton === ele1.schoolId}
                            isZIndex={true}
                          />
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </>
  );
};

export default LiveStreamStatus;
